export class LioUsersTableHeaders {
    allColumns = [
        { field: 'name', header: 'Name', visible: true, activeStatus: true, sort: true, filter: true, minWidth: 160, isDate: false},
        { field: 'email', header: 'Email Address', visible: true, activeStatus: true, sort: true, filter: true, minWidth: 150, isDate: false},
        { field: 'registrationDate', header: 'Registration Date', dateFormat: "dd-MM-yyyy", visible: true, activeStatus: false, sort: true, filter: false , minWidth: 150, isDate: true},
        { field: 'lastLoginDate', header: 'Last login', dateFormat: "dd-MM-yyyy HH:mm", visible: true, activeStatus: true, sort: true, filter: true, minWidth: 150, isDate: true },
    ];
}